<template>
<span>
  <span class="label-info" v-if="this.item.status==2">Wypisany</span>
  <span class="label" v-if="this.item.status==1">Potwierdzony</span>
  <span class="label-alert" v-if="this.item.status==0">Nie potwierdzony</span>
</span>
</template>
<script>
export default {
  props: ['item']
}

</script>


// WEBPACK FOOTER //
// EmailStatus.vue?310e309e